"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  rpc: {},
  types: {
    AcalaStakingLedge: {
      bonded: 'Compact<Balance>',
      unlocking: 'Vec<UnlockChunk>'
    },
    AcalaUnlockChunk: {
      value: 'Compact<Balance>',
      era: 'Compact<EraIndex>'
    }
  }
};
exports.default = _default;